import { concat } from 'lodash'
import { createElement } from 'react'
import { SuggestedQuestion } from '../components/Cards'
import { questions } from '../constants/questions'

export const getRandomSuggestedQuestions = (targetAgents?: string[], questionsPerAgent = 2): SuggestedQuestion[] => {
  const randomQuestions = questions.filter(agent => targetAgents ? targetAgents.includes(agent.agent) : true).map(agent => {
    const agentQuestions = agent.questions

    const shuffled = agentQuestions.sort(() => Math.random() - 0.5)
    return { agent: agent.agent, questions: shuffled.slice(0, questionsPerAgent), Icon: agent.icon }
  })

  let returnQuestions: SuggestedQuestion[] = []

  for (let i = 0; i < questionsPerAgent; i++) {
    returnQuestions = concat(
      returnQuestions,
      randomQuestions.map(question => ({
        agent: question.agent,
        question: question.questions[i],
        icon: createElement(question.Icon),
      })),
    )
  }

  return returnQuestions
}
